<template>
  <Card>
    <div class="activeKeyWrapper">
      <InputText
        :helperText="helperText"
        isDisabled
        label="Private Key Name"
        :value="activeKey.name"
      />
      <div class="btnRegenerateWrapper">
        <IconButton
          :hasNoBackground="false"
          hasOutline
          icon="refresh"
          iconPosition="left"
          text="Regenerate Key"
          type="secondary"
        />
      </div>
    </div>
  </Card>
</template>

<script>
import {
  Card,
  IconButton,
  InputText,
} from '@jumpcloud/ui-components';
import { mapGetters } from 'vuex';
import DateUtil from 'client/util/DateUtil';

const PasswordManagerCloudBackupModule = 'PasswordManagerCloudBackupModule';

export default {
  name: 'PasswordManagerPrivateKeys',

  components: {
    Card,
    IconButton,
    InputText,
  },

  computed: {
    ...mapGetters(PasswordManagerCloudBackupModule, [
      'activeKeys',
    ]),

    activeKey() {
      return this.activeKeys[0];
    },

    helperText() {
      const admin = this.activeKey.createdByAdmin;
      let text = '';

      if (admin?.firstname || admin?.lastname) {
        text = `Downloaded by ${admin.firstname ? `${admin.firstname} ` : ''}${admin.lastname ? `${admin.lastname} ` : ''}- `;
      }

      return `${text}${DateUtil.formatDate(this.activeKey.createdAt)}`;
    },
  },
};
</script>

<style scoped>
@media (min-width: 1024px) {
  .activeKeyWrapper {
    display: flex;
    flex-direction: row;
  }

  .btnRegenerateWrapper {
    margin: var(--jc-spacer-medium) 0 0 var(--jc-spacer-large);
  }
}
</style>
